import { render, staticRenderFns } from "./zjManagerView.vue?vue&type=template&id=83fe6736&scoped=true&"
import script from "./zjManagerView.vue?vue&type=script&lang=js&"
export * from "./zjManagerView.vue?vue&type=script&lang=js&"
import style0 from "./zjManagerView.vue?vue&type=style&index=0&id=83fe6736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fe6736",
  null
  
)

export default component.exports